import type {
  IGetVideoStreamUrlPayload,
  IVideoStreamUrlResponse,
} from "../types/vstr-video";
import type { ApiClient } from "./client";

export class VstrVideoApi {
  constructor(private readonly apiClient: ApiClient) {}

  async getStreamUrl(
    payload: IGetVideoStreamUrlPayload,
  ): Promise<IVideoStreamUrlResponse> {
    const response = await this.apiClient.post<IVideoStreamUrlResponse>(
      "/vstr-video/stream-url",
      payload,
    );
    return response.data;
  }
}
